import { Link } from "react-router-dom";
import { Hammer, Mail } from "lucide-react";
import { Logo, LangToggle } from "@/components/Header";
import { useLang } from "@/lib/i18n";

const TXT = {
  it: { badge: "Sito in costruzione", title: "Stiamo preparando", title2: "la tua prossima casa.", sub: "HomeToB.it è la piattaforma di affitti a medio e lungo termine per aziende, professionisti, proprietari e agenzie. Arriviamo molto presto.", contact: "Scrivici", login: "Accesso riservato" },
  en: { badge: "Under construction", title: "We are getting", title2: "your next home ready.", sub: "HomeToB.it is the medium and long term rental platform for companies, professionals, owners and agencies. Coming very soon.", contact: "Contact us", login: "Private access" },
};

export default function ComingSoon() {
  const { lang } = useLang();
  const t = TXT[lang] || TXT.it;
  return (
    <div className="min-h-screen bg-white text-[#0B192C] flex flex-col" data-testid="coming-soon-page">
      <header className="flex items-center justify-between px-5 sm:px-10 py-6">
        <Logo className="h-10 sm:h-12" />
        <LangToggle />
      </header>
      <main className="flex-1 flex items-center px-5 sm:px-10">
        <div className="max-w-3xl py-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FF6B00]/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#FF6B00]" data-testid="coming-soon-badge">
            <Hammer className="h-4 w-4" /> {t.badge}
          </span>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]" data-testid="coming-soon-title">
            <span className="text-[#142B5C]">{t.title}</span><br /><span className="text-[#FF6B00]">{t.title2}</span>
          </h1>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-slate-600">{t.sub}</p>
          <a href="mailto:info@hometob.it" className="mt-10 inline-flex h-12 items-center gap-2 rounded-full bg-[#FF6B00] px-6 font-bold text-white transition-colors hover:bg-[#e66000]" data-testid="coming-soon-contact-btn">
            <Mail className="h-4 w-4" /> {t.contact}
          </a>
        </div>
      </main>
      <footer className="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-10 py-6 text-xs text-slate-500 border-t border-slate-200">
        <span>© {new Date().getFullYear()} HomeToB.it — Long & medium term houses</span>
        <Link to="/login" className="hover:text-[#142B5C]" data-testid="coming-soon-login-link">{t.login}</Link>
      </footer>
    </div>
  );
}
